import React from 'react'
import { Main } from '../AcademicCurriculum/AcademicCurriculum.element'
import { Directortext } from '../Codeofconduct/Code.element'
import { Directorbackground, Sub } from './Cocurriculum.element'

function Cocurriculum() {
    return (
        <Main>
                   <Directorbackground>
                <Directortext>
                    <h1>Co-curriculum</h1>
                    <p>The New Era Public School| <span>Co-curriculum</span> </p>
                </Directortext>
      
            </Directorbackground> 

            <Sub>
                <p>
                Along with academics, extra-curricular activities play a vital role in the development of the child’s overall growth. Shri-G has always encouraged children to explore their talents. Sports and games in the curriculum ensure healthy and balanced growth of the students, who are encouraged to participate in a wide range of indoor and outdoor games at the school.
                </p>
                <p>
                Outdoor sports include swimming, skating, kabbadi, football, basketball, tennis, cricket, yoga and Martial Arts. In addition to routine art and craft activities, children enjoy creating floral displays, mask making etc. For children with focused interests, we offer Math Club, Eco Club, Quiz and G.K. Clubs, public speaking and Computer Clubs. Dance and music activities, vocal and instrumental music. Keeping track of demands, new activities are also added from time to time.
                </p>


                <p>
                Field trips related to the themes of the curriculum are a common feature at Presidency, especially for Kindergarten and primary school students. Students are trained to develop self- confidence and self-esteem so that they are able to take independent decisions. The school organizes trekking camps as well.

                </p>
            </Sub>
        </Main>
    )
}

export default Cocurriculum
